import React, {Fragment} from "react";
import "../../scss/CustomerIndex.css"
import ToastHelper from "../../utils/ToastHelper";
import AgentService from "../../services/Agent/AgentService";
import SectionHeader from "./SectionHeader";
import {Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import * as Yup from "yup";
import ValidatableObjectComponent from "../../components/ValidatableObjectComponent";
import LoadingSpinnerComponent from "../../components/LoadingSpinnerComponent";
import CreateObjectRowWithLabelComponent from "../../components/CreateObjectRowWithLabelComponent";
import AutoUploadDocumentUploadComponent from "../../components/AutoUploadDocumentUploadComponent";

export default class AgentIdentityDetailsComponent extends React.Component {

    constructor(props) {
        super(props);
        this.identityValidationConfig = [
            {
                dataField: "idType", dataLabel: "Id Type", type: "select", selectOptions:
                    [
                        {value: "SA_ID", text: "SA ID"},
                        {value: "FOREIGN_PASSPORT", text: "Foreign Passport"},
                        {value: "ASYLUM_PAPER", text: "Asylum Paper"}
                    ],
                yup: Yup.string()
                    .required('Identity Type is required')
            },
            {
                dataField: "idNumber", dataLabel: "Id Number",
                yup: Yup.string()
                    .required('ID number is required')
            },
            {
                dataField: "idExpiryDate", dataLabel: "ID Expiry Date", type: "date",
                yup: Yup.string()
                    .required('ID Expiry Date is required')
            },
            {
                dataField: "idIssuingCountry", dataLabel: "ID Issuing Country",
                type: "select-country",
                yup: Yup.string()
                    .required('ID Issuing Country is required')
            },
            {
                dataField: "nationality", dataLabel: "Nationality",
                type: "select-country",
                yup: Yup.string()
                    .required('Nationality is required')
            },
            {
                dataField: "originCountry", dataLabel: "Origin Country",
                type: "select-country",
                yup: Yup.string()
                    .required('Origin Country is required')
            }
        ];

        this.viewRef = {};
        this.state = {
            isPopupOpen: false,
            loading: false,
            detailsValid: true,
            idUploaded: false,
            showCheckBox: true
        }
    }

    toggleModal() {
        this.setState({
            isPopupOpen: !this.state.isPopupOpen,
            detailsValid: false,
            idUploaded: false,
            stillValid: false,
            showCheckBox: true
        })
    };

    editSubmit() {
        this.setState({loading: true})
        let newValues = this.viewRef.getValues();
        let newState = {loading: false}
        AgentService.updateIdentity(this.props.agentId, newValues).then(response => {
            if (response.idNumber) {
                newState.loading = false
                newState.isPopupOpen = false
                newState.detailsValid = false;
                ToastHelper.success("Identity details updated.");
            } else {
                ToastHelper.formatError(response);
            }
            this.setState(newState, this.props.onRefresh);
        });
    }

    uploadDocument(file) {
        let documentRequest = {
            agentDocumentType: "IDENTITY",
            metaDataId: file.id
        };
        let document = this.props.documents.find((element) => element.agentDocumentType === 'IDENTITY');
        if (document) {
            this.submitUpdate(file, document.id, documentRequest);
        }else{
            this.submitNew(documentRequest)
        }
    }

    submitUpdate(file, documentId, updateRequest) {
        let newState = {documentsLoading: false}

        AgentService
            .updateDocument(this.props.agentId, documentId, updateRequest)
            .then(response => {
                if (response.id) {
                    newState.idUploaded = true;
                    newState.document = response;
                    newState.detailsValid = false;
                    newState.showCheckBox = false;
                    ToastHelper.success("Document updated.");
                } else {
                    ToastHelper.formatError(response);
                }
                this.setState(newState);
            });
    }

    submitNew(documentRequest) {
        let newState = {documentsLoading: false}

        AgentService
            .addDocument(this.props.agentId, documentRequest)
            .then(response => {
                if (response.id) {
                    newState.idUploaded = true;
                    newState.document = response;
                    newState.detailsValid = false;
                    newState.showCheckBox = false;
                    ToastHelper.success("Document Added.");
                } else {
                    ToastHelper.formatError(response);
                }
                this.setState(newState);
            });
    }

    render() {

        let identity = this.props.identity;
        return <div>
            <SectionHeader text={"IDENTITY DETAILS"} onEditClick={this.toggleModal.bind(this)}
                           canEdit={this.props.canEdit}/>
            <div>
                <CreateObjectRowWithLabelComponent label={"ID Number"} className={"pull-left"}>
                    {identity.idNumber}
                </CreateObjectRowWithLabelComponent>

                <CreateObjectRowWithLabelComponent label={"ID Expiry Date"} className={"pull-left"}>
                    {identity.idExpiryDate}
                </CreateObjectRowWithLabelComponent>
            </div>
            {this.state.isPopupOpen && this.showModal()}
        </div>

    }

    showModal() {
        return <Fragment>
            <Modal isOpen={this.state.isPopupOpen}
                   className={'modal-primary modal-md'}>
                <ModalHeader toggle={this.toggleModal.bind(this)}>Edit Identity details</ModalHeader>
                <ModalBody>
                    {this.state.loading
                        ? <LoadingSpinnerComponent/>
                        : this.renderIdentityEditForm()}
                </ModalBody>
                <ModalFooter className={'sideBySide'}>
                    {this.state.showCheckBox && <div style={{paddingLeft: 10}}>
                        <Input
                            onChange={() => {
                                this.setState(
                                    {
                                        stillValid: !this.state.stillValid
                                    }
                                )
                            }}
                            type="checkbox"
                            checked={this.state.stillValid}
                        />
                        <b>My ID details are still valid</b>
                    </div>
                    }
                    {(this.state.stillValid || this.state.idUploaded) &&
                        <SFXButtonComponent className="btn btn-block btn-primary" onClick={this.editSubmit.bind(this)}>
                            Submit
                        </SFXButtonComponent>}

                </ModalFooter>
            </Modal>
        </Fragment>
    }

    renderIdentityEditForm() {
        return <Fragment>
            <ValidatableObjectComponent
                ref={(ref) => (this.viewRef = ref)}
                config={this.identityValidationConfig}
                defaultValues={this.props.identity}
                readOnly={this.state.stillValid}
                hideCreateFields={false}
                onValidChanged={(valid) => {
                    this.setState({
                        detailsValid: valid
                    })
                }}
            />

            {!this.state.stillValid && <Fragment>
                <hr/>
                <CreateObjectRowWithLabelComponent label={"Upload ID Document *"} className={"pull-left"}>
                    <AutoUploadDocumentUploadComponent
                        documentType={"AGENT_DOCUMENT"}
                        showButton={true}
                        buttonConfig={{"buttonText": "ID Document"}}
                        className={"mobile"}
                        onFileSelected={() => this.setState({documentsLoading: true, idUploaded: false})}
                        onUploadSuccessful={(file) => {
                            this.uploadDocument(file)
                        }}/>
                </CreateObjectRowWithLabelComponent>
            </Fragment>
            }
        </Fragment>
    }
}
